const loginForm = document.getElementById("new_user_session")
if (loginForm) {
  loginForm.action = loginForm.action + window.location.hash
}

let localeMenuToggler, localeMenu, localeMenuItems
let menuOpenedByHover = false

document.addEventListener("readystatechange", () => {
  if (document.readyState === "complete") {
    localeMenuToggler = document.querySelector(".js-locale-menu-toggler")
    localeMenu = document.querySelector(".js-locale-menu")

    if (localeMenuToggler) {
      localeMenuToggler.addEventListener("click", function () {
        if (!menuOpenedByHover) {
          toggleMenu(this, !(this.getAttribute("aria-expanded") === "true" || false), true)
        }
      })
      localeMenuToggler.addEventListener("mouseenter", function () {
        menuOpenedByHover = true
        toggleMenu(this, true)
      })
      localeMenuToggler.addEventListener("focus", function () {
        toggleMenu(this, true)
      })
      localeMenuToggler.addEventListener("mouseleave", collapse)
      localeMenuToggler.addEventListener("blur", collapse)
    }

    if (localeMenu && localeMenuToggler) {
      localeMenuItems = localeMenu.querySelectorAll("ul > li a")

      if (localeMenuItems) {
        localeMenuItems[0].addEventListener("blur", closeMenuOnBlur)
        localeMenuItems[localeMenuItems.length - 1].addEventListener("blur", closeMenuOnBlur)
      }

      localeMenu.addEventListener("mouseleave", function (e) {
        const toggler = localeMenu.previousElementSibling
        if (menuOpenedByHover && !toggler.isSameNode(e.relatedTarget)) {
          menuOpenedByHover = false
          toggleMenu(toggler, false)
        }
      })
    }
  }
})

document.addEventListener("submit", (event) => {
  const form = event.target

  if (!form.matches('[data-disable-until-response="true"]')) {
    return
  }

  if (form.dataset.submitting === "true") {
    event.preventDefault()
    return
  }

  form.dataset.submitting = "true"
})

/** Custom listener to pick up unlocalized time and format it
 * accordingly to the client's local time.
 *
 * Used in the blocked_mfa view, where timezone is unknown for some (Meta) users
 *
 */
document.addEventListener("readystatechange", () => {
  if (document.readyState !== "complete") return

  document.querySelectorAll("[data-local-time-needed]").forEach((element) => {
    const date = new Date(element.dataset.utcTime)
    const template = element.dataset.localTimeTemplate

    if (!template) {
      return
    }

    if (Number.isNaN(date.getTime())) {
      return
    }

    const localizedDateTime = new Intl.DateTimeFormat(navigator.language, {
      dateStyle: "short",
      timeStyle: "short",
    }).format(date)

    element.textContent = template.replace("__TIME__", localizedDateTime)
  })
})

const toggleMenu = function (toggler, expand) {
  toggler.setAttribute("aria-expanded", expand)
  const menu = toggler.nextElementSibling
  menu.hidden = !expand
  if (expand) {
    menu.classList.remove("hidden")
  } else {
    menu.classList.add("hidden")
  }

  setTimeout(() => {
    window.scrollTo(0, document.body.scrollHeight)
  }, 10)
}
const collapse = function (e) {
  if (!isWithinNode(e.relatedTarget, localeMenu)) {
    menuOpenedByHover = false

    toggleMenu(e.target, false)
  }
}

const isWithinNode = function (current, reference) {
  while (current) {
    if (current.isSameNode(reference)) {
      return true
    }

    current = current.parentElement
  }

  return false
}

// collapse a sub-menu when the user tabs out of it
const closeMenuOnBlur = function (e) {
  if (!isWithinNode(e.relatedTarget, localeMenu)) {
    toggleMenu(localeMenuToggler, false)
  }
}
